export default __webpack_public_path__ + "static/media/Hair_5_M_C3.a65418ad.svg";